export interface AboutContent {
  brandIntro: {
    title: string;
    paragraphs: string[];
  };
  milestones: {
    year: string;
    title: string;
    description: string;
  }[];
  reputation: {
    title: string;
    items: {
      icon: string;
      title: string;
      description: string;
    }[];
  };
  contact: {
    title: string;
    address: string;
    phone: string;
    email: string;
    workingHours: string;
  };
  faqs: {
    question: string;
    answer: string;
  }[];
}

export const aboutContent: AboutContent = {
  brandIntro: {
    title: '关于向日葵视频',
    paragraphs: [
      '向日葵视频成立于2020年，是一家专注于数字视频内容聚合与分发的综合性在线视频平台。我们致力于为广大用户提供91视频、97视频、51视频、久久视频等高品质数字视频内容的免费在线观看服务，打造最全面的数字视频大全。',
      '平台自上线以来，始终秉持"让优质视频触手可及"的理念，通过先进的内容聚合技术和智能推荐算法，为用户精选海量高清视频资源。无论是热门影视、综艺娱乐、纪录片，还是教育课程、游戏实况、生活Vlog，向日葵视频都能满足您的多样化观影需求。',
      '经过多年的发展，向日葵视频已经积累了超过5000万的注册用户，日均活跃用户超过800万。我们的内容库涵盖超过100万部视频资源，每日更新超过5000部新内容，是国内领先的数字视频在线观看平台之一。',
      '展望未来，向日葵视频将继续深耕数字视频领域，不断优化用户体验，拓展内容品类，引入更多优质的91视频同类型平台资源，让每一位用户都能在这里找到自己喜欢的内容。我们相信，视频让世界更精彩。',
    ],
  },
  milestones: [
    {
      year: '2020',
      title: '平台创立',
      description: '向日葵视频正式上线，以91视频、97视频内容为核心，开启数字视频聚合服务。',
    },
    {
      year: '2021',
      title: '用户突破千万',
      description: '平台注册用户突破1000万，新增51视频、久久视频等内容频道，内容品类持续扩展。',
    },
    {
      year: '2022',
      title: '技术升级',
      description: '完成AI智能推荐系统升级，实现个性化内容推送，用户观看时长提升60%。',
    },
    {
      year: '2023',
      title: '内容破百万',
      description: '平台视频资源总量突破100万部，日更新量超过3000部，成为数字视频大全领先平台。',
    },
    {
      year: '2024',
      title: '移动端全面优化',
      description: '推出全新移动端体验，支持离线缓存、画质自适应等功能，移动端用户占比达70%。',
    },
    {
      year: '2025',
      title: '生态拓展',
      description: '与超过200家内容方达成合作，引入更多91视频同类型平台资源，打造开放视频生态。',
    },
    {
      year: '2026',
      title: 'AI赋能',
      description: '全面引入AI技术，实现智能字幕、AI摘要、个性化内容创作辅助等创新功能。',
    },
  ],
  reputation: {
    title: '平台口碑与荣誉',
    items: [
      {
        icon: 'ri-award-line',
        title: '行业认可',
        description: '连续三年荣获"最佳数字视频平台"称号，获得中国互联网协会颁发的"优秀视频服务平台"认证。',
      },
      {
        icon: 'ri-user-heart-line',
        title: '用户信赖',
        description: '用户满意度评分持续保持在9.2分以上，超过95%的用户表示愿意向朋友推荐向日葵视频。',
      },
      {
        icon: 'ri-shield-check-line',
        title: '安全可靠',
        description: '通过ISO 27001信息安全认证，采用银行级数据加密技术，全方位保障用户隐私和数据安全。',
      },
      {
        icon: 'ri-rocket-line',
        title: '技术创新',
        description: '拥有超过50项自主知识产权技术专利，在视频编码、传输优化、智能推荐等领域保持行业领先。',
      },
    ],
  },
  contact: {
    title: '联系我们',
    address: '北京市朝阳区建国路88号SOHO现代城A座15层',
    phone: '400-888-6688',
    email: 'contact@xiangrikuishipin.com',
    workingHours: '周一至周日 9:00 - 21:00',
  },
  faqs: [
    {
      question: '向日葵视频是免费的吗？',
      answer: '是的，向日葵视频平台上的所有视频内容均免费提供在线观看，您无需支付任何费用即可畅享海量高清数字视频资源。',
    },
    {
      question: '平台支持哪些设备观看？',
      answer: '向日葵视频全面支持PC端、手机端和平板端观看。您可以通过浏览器直接访问，也可以下载我们的移动客户端，享受更便捷的观看体验。支持iOS和Android系统。',
    },
    {
      question: '视频画质如何？支持高清播放吗？',
      answer: '向日葵视频平台上的大部分内容均支持高清（1080P）播放，部分精选内容支持超高清（4K）播放。系统会根据您的网络状况自动调整最佳画质，您也可以手动选择画质。',
    },
    {
      question: '91视频和97视频有什么区别？',
      answer: '91视频频道侧重于热门影视和动漫内容，97视频频道则更注重经典影片和美食旅行类内容。两个频道各有特色，您可以根据自己的喜好选择观看。当然，51视频和久久视频频道同样提供了丰富多样的视频内容。',
    },
    {
      question: '如何搜索我想看的视频？',
      answer: '您可以在页面顶部的搜索框中输入关键词进行搜索，也可以通过分类导航浏览不同频道的视频内容。我们的智能推荐系统还会根据您的观看历史，为您推荐可能感兴趣的视频。',
    },
  ],
};